class AtomicPurchaseProduct extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    this.radios = [...this.querySelectorAll('[data-purchase-radio]')];
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.update(), { signal: this.events.signal }));
    this.update();
  }

  disconnectedCallback() {
    this.events?.abort();
  }

  update() {
    const selected = this.radios.find((radio) => radio.checked);
    if (!selected) return;
    const plan = selected.value;
    const subscription = plan === 'sub';
    const price = subscription ? this.dataset.subPrice : plan === 'multi' ? this.dataset.multiPrice : this.dataset.onePrice;
    const quantity = this.querySelector('[data-product-quantity]');
    const sellingPlan = this.querySelector('[data-selling-plan]');
    if (quantity) quantity.value = plan === 'multi' ? '3' : '1';
    if (sellingPlan) sellingPlan.disabled = !subscription;
    this.querySelectorAll('[data-product-price], [data-atc-price]').forEach((node) => { node.textContent = price; });
    this.querySelectorAll('[data-purchase-details]').forEach((panel) => { panel.hidden = panel.dataset.purchaseDetails !== plan; });
    this.querySelector('[data-purchase-daily]').textContent = subscription ? this.dataset.subDaily : this.dataset.oneDaily;
    this.querySelector('[data-price-context]').textContent = subscription ? 'per monthly shipment' : 'one-time total';
    const supply = this.querySelector('[data-purchase-supply]');
    if (supply) supply.textContent = plan === 'multi'
      ? '180 capsules · 90 two-capsule servings · 90-day supply'
      : supply.dataset.singleSupply;
    this.querySelector('[data-purchase-terms]').textContent = subscription
      ? `${price} every 30 days. Change, pause, or cancel anytime.`
      : 'One-time purchase. No recurring charges.';
    const sticky = [...document.querySelectorAll('[data-purchase-sticky]')].find((node) => node.dataset.purchaseSticky === this.dataset.formId);
    if (sticky) sticky.textContent = `${subscription ? 'Monthly' : plan === 'multi' ? '3 pouches' : 'One-time'} · ${price}`;
  }
}

if (!customElements.get('atomic-purchase-product')) customElements.define('atomic-purchase-product', AtomicPurchaseProduct);
